import axios from 'axios';
import {apiConfigs} from "../configs/api";
import {store} from "../index";
import {refreshTokenAction} from "../actions/auth";

export async function refreshTokenRequest(failedRequestConfig) {
    const slug = window.location.pathname.split('/')[1];
    const userData = JSON.parse(localStorage.getItem('persist:auth')) || {};
    const activeRefreshToken = userData.refreshToken ? JSON.parse(userData.refreshToken) : null;
    const activeToken = userData.token ? JSON.parse(userData.token) : null;
    const res = await axios.post(`https://${slug}.${apiConfigs.hostUrlV2}refresh_token?token=${activeToken}&refresh_token=${activeRefreshToken}`);
    const {token, refresh_token} = res.data;
    localStorage.setItem('persist:auth', JSON.stringify({
        ...userData,
        token: JSON.stringify(token),
        refreshToken: JSON.stringify(refresh_token),
    }));
    store.dispatch(refreshTokenAction({token, refresh_token}));
    failedRequestConfig.headers['Authorization'] = `Bearer ${token}`;
    return axios(failedRequestConfig);
}

export const ApiService = {
    apiCall: ({
                  endpoint = '',
                  method = 'GET',
                  query = {},
                  headers = {},
                  qsParams = {},
              }) => {
        const HTTPMethod = method.toLowerCase()
        const slug = window.location.pathname.split('/')[1];
        const localStorageUserData = localStorage.getItem('persist:auth');
        const userData = JSON.parse(localStorageUserData);
        const activeToken = userData?.token ? JSON.parse(userData.token) : null;
        const currentHeaders = activeToken ? {
            ...headers,
            Authorization: `Bearer ${activeToken}`
        } : {
            ...headers
        }
        const api = axios.create({
            baseURL: `https://${slug}.${apiConfigs.hostUrlV2}`,
            headers: currentHeaders,
            params: qsParams || {},
        })
        api.interceptors.request.use((config) => {
            return config;
        }, (error) => {
            return Promise.reject(error);
        });

        return api[HTTPMethod](endpoint, query).catch((error) => {
            if (error.response?.data?.message === 'Signature has expired') {
                return refreshTokenRequest(error.config);
            }
            throw error;
        });
    },
}

export default ApiService;
